"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NumberInput = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const react_hook_form_1 = require("react-hook-form");
const text_1 = require("../text");
const NumberInput = props => {
    const { name, allowNegative = false, defVal = 0, readOnly, helperText, enableKeyboardSpinPreview = false, inputProps, onBlur, onChange, onKeyDown, onKeyUp, ...rest } = props;
    const form = (0, react_hook_form_1.useFormContext)();
    const previewValueRef = (0, react_1.useRef)(null);
    const isBlockedKey = (e) => e.keyCode === 69 || (!allowNegative && e.keyCode === 189) || (e.shiftKey && e.keyCode === 187);
    const formatValue = (value) => {
        return !value && value !== 0 ? "" : Number(value);
    };
    const getNumericInputProp = (value) => {
        if (value === undefined || value === null || value === "any")
            return null;
        const numericValue = Number(value);
        return Number.isFinite(numericValue) ? numericValue : null;
    };
    const getDecimalPlaces = (value) => {
        const valueString = value.toString().toLowerCase();
        const [, exponent = "0"] = valueString.split("e-");
        if (valueString.includes("e-"))
            return Number(exponent);
        return valueString.split(".")[1]?.length ?? 0;
    };
    const roundToStepPrecision = (value, step) => {
        const precision = Math.max(getDecimalPlaces(value), getDecimalPlaces(step));
        return Number(value.toFixed(precision));
    };
    const commitValue = (value) => {
        form.setValue(name, value, { shouldTouch: true, shouldDirty: true, shouldValidate: true });
        void form.trigger(name);
    };
    const commitPreviewValue = () => {
        if (previewValueRef.current === null)
            return;
        commitValue(previewValueRef.current);
        previewValueRef.current = null;
    };
    const stepKeyboardSpin = (input, direction) => {
        const step = getNumericInputProp(inputProps?.step) ?? 1;
        const min = getNumericInputProp(inputProps?.min);
        const max = getNumericInputProp(inputProps?.max);
        const currentValue = input.value === "" ? defVal : Number(input.value);
        if (!Number.isFinite(currentValue))
            return;
        const nextValueRaw = currentValue + step * direction;
        const nextValueWithMin = min === null ? nextValueRaw : Math.max(nextValueRaw, min);
        const nextValue = max === null ? nextValueWithMin : Math.min(nextValueWithMin, max);
        const roundedValue = roundToStepPrecision(nextValue, step);
        input.value = String(roundedValue);
        previewValueRef.current = roundedValue;
    };
    const handleKeyDown = (e) => {
        if (isBlockedKey(e)) {
            // disallow e/-/+
            e.preventDefault();
            return;
        }
        if (!readOnly && enableKeyboardSpinPreview && (e.key === "ArrowUp" || e.key === "ArrowDown")) {
            e.preventDefault();
            stepKeyboardSpin(e.currentTarget, e.key === "ArrowUp" ? 1 : -1);
            onKeyDown?.(e);
            return;
        }
        onKeyDown?.(e);
    };
    const handleKeyUp = (e) => {
        if (enableKeyboardSpinPreview && (e.key === "ArrowUp" || e.key === "ArrowDown")) {
            commitPreviewValue();
        }
        onKeyUp?.(e);
    };
    const handleChange = (e) => {
        const newValue = formatValue(e.target.value);
        form.setValue(name, newValue, {
            shouldTouch: true,
            shouldDirty: true,
            shouldValidate: true,
        });
        void form.trigger(name);
        onChange?.(e);
    };
    const handleOnBlur = (e) => {
        if (readOnly) {
            return;
        }
        commitPreviewValue();
        if (onBlur) {
            onBlur(e);
            return;
        }
        const value = e.target.value;
        if (!value) {
            form.setValue(name, defVal, { shouldTouch: true, shouldDirty: true });
            void form.trigger(name);
        }
        else {
            form.setValue(name, Number(value), { shouldTouch: true, shouldDirty: true });
            void form.trigger(name);
        }
    };
    return ((0, jsx_runtime_1.jsx)(text_1.TextInput, { sx: { my: 1 }, type: "number", onKeyDown: handleKeyDown, onKeyUp: handleKeyUp, onBlur: handleOnBlur, formatValue: formatValue, name: name, readOnly: readOnly, helperText: helperText, inputProps: inputProps, ...(enableKeyboardSpinPreview || onChange
            ? { onChange: enableKeyboardSpinPreview ? handleChange : onChange }
            : {}), ...rest }));
};
exports.NumberInput = NumberInput;
//# sourceMappingURL=index.js.map